import { ReactNode } from 'react';

import { Text } from '@/core/tamagoshi/Text/Text';
import {
  manoExpressExplanationTextBody,
  manoExpressExplanationTextSubText,
  manoExpressExplanationTextTitle,
} from '@/productDiscovery/Listings/components/Filters/components/DeliveryFilter/translations';

import styles from './FilterExplanation.module.scss';

export const ecoExplanationText = (
  <Text>
    Retrouvez ici les produits disposant d&apos;un label ou d&apos;une
    <strong> certification environnementale</strong> (matières premières
    responsables, qualité de l&apos;air intérieur élevée…) ayant un impact
    réduit sur l&apos;environnement et la santé.
  </Text>
);

export const madeInFranceExplanationText = (
  <Text>
    Choisir un produit
    <strong> d&apos;origine France</strong> c&apos;est favoriser l&apos;activité
    locale et un transport réduit du produit.
  </Text>
);

export const mmfExplanationText = (
  <Text>
    Livraison en 48h gratuite et retours gratuits pendant 100 jours par ManoMano
    <ul>
      <li>
        Livraison par ManoMano, gratuitement en point relais ou à domicile dans
        les 2 jours max* même pour les produits lourds et encombrants**.
      </li>
      <li>
        Retours gratuits pendant 100 jours et remboursement à réception de la
        preuve d’expédition ou du produit, dans les entrepôts ManoMano.
      </li>
    </ul>
    <div className={styles.baseline}>
      *Suivant l&apos;heure de votre commande.
      <br />
      **Selon éligibilité de la zone. Commandes inférieures à 70kg. Pour des
      commandes de moins de 39€ des frais supplémentaires pourraient être
      appliqués.
    </div>
  </Text>
);

export const manoExpressExplanationText = (
  <Text>
    <Text className={styles.headline}>{manoExpressExplanationTextTitle}</Text>

    {manoExpressExplanationTextBody.format({
      tag: (chunks: ReactNode) => <Text tag="p">{chunks}</Text>,
    })}

    {manoExpressExplanationTextSubText.format({
      tag: (chunks: ReactNode) => (
        <Text tag="p" className={styles.baseline}>
          {chunks}
        </Text>
      ),
    })}
  </Text>
);
